export default __webpack_public_path__ + "static/909-3f925f7447a6942baf66cabd93f5fde1.gif";